import { useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { searchActions } from './search.actions';
import { SearchView } from './search.view';
import { createSearchUrl } from './utils/url/createSearchUrl';

/** Redirects to the persisted Search state when the route is entered without search params. */
const SearchRoute = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const searchParams = useAppSelector((state) => state.search.params);

  // Captured on mount so later back/forward navigation to a bare URL isn't redirected.
  const [initialRedirect] = useState(() => ({
    key: location.key,
    url: location.search ? undefined : createSearchUrl(searchParams),
  }));

  // Entering with explicit params means the persisted saved search is no longer being viewed.
  useEffectOnce(() => {
    if (location.search) {
      dispatch(searchActions.savedSearch.unset());
    }
  });

  if (
    location.key === initialRedirect.key &&
    initialRedirect.url?.includes('?')
  ) {
    return <Navigate to={initialRedirect.url} replace />;
  }

  return <SearchView />;
};

export const SearchRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route index element={<Navigate to="conversations" replace />} />
      <Route path="conversations" element={<SearchRoute />} />
    </Routes>
  );
};
